import { render, staticRenderFns } from "./systemNewsList-dialog.vue?vue&type=template&id=31a0c34c&scoped=true"
import script from "./systemNewsList-dialog.vue?vue&type=script&lang=js"
export * from "./systemNewsList-dialog.vue?vue&type=script&lang=js"
import style0 from "./systemNewsList-dialog.vue?vue&type=style&index=0&id=31a0c34c&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a0c34c",
  null
  
)

export default component.exports